import { render, staticRenderFns } from "./registerAsOwner.vue?vue&type=template&id=d7b6f732&"
import script from "./registerAsOwner.vue?vue&type=script&lang=js&"
export * from "./registerAsOwner.vue?vue&type=script&lang=js&"
import style0 from "./registerAsOwner.vue?vue&type=style&index=0&id=d7b6f732&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports